/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Priority_AriaInputs */

const en_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const fr_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const de_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const it_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const ru_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const es_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const zh_cn2_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const ja_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const hi_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

const pt_pt2_explorer_info_priority_aria = /** @type {(inputs: Explorer_Info_Priority_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit priority`)
};

/**
* | output |
* | --- |
* | "Edit priority" |
*
* @param {Explorer_Info_Priority_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_priority_aria = /** @type {((inputs?: Explorer_Info_Priority_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Priority_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_priority_aria(inputs)
	if (locale === "de") return de_explorer_info_priority_aria(inputs)
	if (locale === "it") return it_explorer_info_priority_aria(inputs)
	if (locale === "ru") return ru_explorer_info_priority_aria(inputs)
	if (locale === "es") return es_explorer_info_priority_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_priority_aria(inputs)
	if (locale === "ja") return ja_explorer_info_priority_aria(inputs)
	if (locale === "hi") return hi_explorer_info_priority_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_priority_aria(inputs)
	return en_explorer_info_priority_aria(inputs)
});